module.exports = __webpack_public_path__ + "static/media/growth.ddf08051.gif";